import React,{ useState} from 'react'
import BooksListContainer from "../containers/booksListContainer"
import DigitalBooks from './digitalBooks'

function Books({data}) {

  const [first, setfirst] = useState(true)

  return (

    <div>

              <div className="p-3 greenhouseBg">
                    <h1 className="text-white tittle mt-5">BIBLIOTECA VIRTUAL</h1>
                    <p className="text-white mb-5">Consulta aquí acerca de los libros disponibles en la biblioteca y si se encuentran o no disponibles para ser prestados.</p>
              </div>

          <div>
          <div className='text-center regularText pt-5'>
            <h2>Selecciona la biblioteca:</h2>
          <div className='p-3 d-flex gap-3 justify-content-center creamBackground rounded-4 p-3 m-3'>
                <span onClick={(e) => setfirst(false)} className= {first==false? 'regularText fs-2 text-white px-3 rounded-3 militaryBackground':'regularText fs-2 text-white px-3 rounded-3 bg-dark'}>Biblioteca virtual </span>

                <span onClick={(e) => setfirst(true)} className={first==true? 'regularText fs-2 text-white px-3 rounded-3 militaryBackground':'regularText fs-2 text-white px-3 rounded-3 bg-dark'}>Biblioteca física </span>
            </div>
            </div>

            </div>

          {first?
          <div>
              <div className='p-3'> 
                <BooksListContainer data={data}/>
              </div>
          </div>
          :
          <div>
            <DigitalBooks/>
          </div>
      
    }
    
        
    </div>
  )
}

export default Books